import { getPointsBankName } from "web/utils/page/product/subscription/prepareBenefitsPricesOption";

import { IBankItem } from "web/types/Banks";
import {
  ISubscriptionAsideTotalsItem,
  ISubscriptionPointsBank,
} from "web/types/Subscription";

import { ProcessedPointBank } from "./setAllPointsBanks";

type PreparedPonintBank = {
  pointsBankId: ISubscriptionAsideTotalsItem["pointsBankId"];
  pointsBankPrice: string | number;
  name: ISubscriptionAsideTotalsItem["name"];
};

type PreparePointBanksFn = (
  pointsBanksArray: (ProcessedPointBank | ISubscriptionPointsBank)[],
  availablePointsBanks?: IBankItem[]
) => PreparedPonintBank[];

const preparePointsBanks: PreparePointBanksFn = (
  pointsBanksArray,
  availablePointsBanks
) => {
  const pointsBanksResult: PreparedPonintBank[] = [];
  pointsBanksArray.forEach((bank) => {
    const ifBankExist = pointsBanksResult.find(
      (ele) => ele?.pointsBankId === bank.pointsBankId
    );
    if (ifBankExist) {
      const index = pointsBanksResult.findIndex(
        (addedItem) => addedItem?.pointsBankId === bank.pointsBankId
      );
      if (index !== -1)
        pointsBanksResult[index] = {
          ...pointsBanksResult[index],
          pointsBankPrice:
            +pointsBanksResult[index]?.pointsBankPrice + +bank.pointsBankPrice,
        };
    } else {
      pointsBanksResult.push({
        ...bank,
        name: getPointsBankName(availablePointsBanks, bank.pointsBankId),
      });
    }
  });

  return pointsBanksResult;
};

export default preparePointsBanks;
